import React from "react";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "../../../../../../Services/axiosCommon";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
// import Attachement from "./Attachement";
import Dasboard from "../../../../../../Components/Icons/Dasboard";
import * as yup from "yup";
import { Modal, notification } from "antd";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
import { NuInput, NuLabel, NuSelect, NuTextArea } from "../../../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";
import axiosInstance from "../../../../../../Services/axiosCommon";
import UseCatSubCatDropDown from "../../../../../../Components/Hooks/useCategoryDropDown";



function EditEquipment({open, getData, onCancel, data,id,projectId,Unit,Type,Activity }) {
//   const {value:Unit ,getData:  UnitEquipment} = useFetchMataData(`/dropdown/dropdown-details/`,'Unit_item')
// const {value:Type ,getData:  TypeEquipment} = useFetchMataData(`/dropdown/dropdown-details/`,'TypeEquipment')
  // const {value:Category ,getData:  ManPowerCategory} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerCategory')
  // const {value:Type ,getData:  ManPowerType} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerType')
    const [api, contextHolder] = notification.useNotification();
  const [isLoading,setIsLoading] = useState(false);
  const [createNew, setCreateNew] = useState({
    projectId:"",
  title_id:"",
  item:"",
  unit:"",
  type:"",
  quantity:"",
  unitPrice:"",
  totalPrice:"",
  });
  useEffect(() => {
    data&&setCreateNew({
    item: data?.item || "",
    unit: data?.unit || "",
    type: data?.type || "",
    quantity: data?.quantity || "",
    unitPrice: data?.unitPrice || "",
    totalPrice: data?.totalPrice || "",
    
   
    })
  },[data])
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: createNew,
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema:yup.object({
         item:yup.string().required("Desigination Name is Requried")
        }),
        onSubmit: (value,{resetForm}) => {
          axiosInstance.put(`/budget-equipment/update/${data?.id}`, value)
          .then((res) => {
              console.log("res",res.data.status);
              if (res.data.status) {
                getData(id);
                resetForm();
                api.success({
                  message: `Equipment Item Update successfully`,
                description: res?.data?.msg || "Added In The Activity",
                  placement: "bottomRight",
                });
                onCancel();
              } else {
                api.error({
                  message: `Equipment Item Upadate failed`,
                  description: res?.data?.msg || "Network error",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              api.error({
                message: `failed`,
                description: err?.data?.msg || "Sever error (or) Network error",
                placement: "bottomRight",
              });
            });
        },
      });
      useEffect(() => {
        const totalPrice = formik?.values?.quantity * formik?.values?.unitPrice
        formik.setFieldValue("totalPrice", totalPrice);
      }, [formik?.values?.quantity,formik?.values?.unitPrice]);
      // const { category: itemsCategory, subCategory: itemsSubCategory } =
      // UseCatSubCatDropDown(
      //   "/category/ItemCategory",
      //   "ItemCategory",
      //   formik?.values?.category
      // );
      return (
        <>
        {contextHolder}
        <Modal
          open={open}
          title={"Edit Equipment Item"}
          width={"50%"}
          className="my-modal"
          centered
          footer={[]}
          onCancel={onCancel}
        >
        <form onSubmit={formik.handleSubmit} >
          <div className=" w-full flex flex-wrap">
          <FormikSelectTwo
           
           label="Item"
           placeholder="Item"
           formik={formik}
           name="item"
           
           isRequired={true}
           Options={Activity}
           width="w-full "               
            
       />
             <FormikSelectTwo
          label="Type"
          width="w-full md:w-1/2"    
          formik={formik}
          placeholder="Choose"
          name="type"
          Options={Type}
          />
      
           <FormikSelectTwo
          label="Unit"
          width="w-full md:w-1/2"    
          formik={formik}
          placeholder="Choose"
          name="unit"
          Options={Unit}
          />
            
           <NuInput
              type="number"
              label=" Quantity"
              placeholder=" Quantity"
              formik={formik}
              name="quantity"
              width="w-full md:w-1/2"
            />
            <NuInput
                         type="number"

              label="UnitPrice"
              placeholder="unitPrice"
              formik={formik}
              name="unitPrice"
              width="w-full md:w-1/2"
            />
            <NuInput
                         type="number"

              label="TotalPrice"
              placeholder="totalPrice"
              formik={formik}
              name="totalPrice"
              width="w-full md:w-1/2"
              disabled={true}
            />
                <div className="w-full flex justify-end item-end float-right mx-auto md:mx-0 gap-2 mt-2 md:mr-4">
                  <CancelButton handleClick={onCancel} />
                  <SubmitButton isLoading={isLoading} />
                </div>
          </div>
          </form>
        </Modal>
        </>
      )
}

export default EditEquipment;